import { __decorate, __param } from 'tslib';
import { Inject, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isString } from '@egovsolutions/type-checking';
import { DialogCloseButtonModule } from '@egovsolutions/angular-dialog-close-button';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@egovsolutions/angular-dialog-close-button';

function GenericModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function GenericModalComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function GenericModalComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, GenericModalComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.template);
} }
let GenericModalComponent = class GenericModalComponent {
    constructor(
    // Passed content
    content) {
        if (isString(content))
            this.content = content;
        else
            this.template = content;
    }
};
GenericModalComponent.ɵfac = function GenericModalComponent_Factory(t) { return new (t || GenericModalComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
GenericModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GenericModalComponent, selectors: [["egov-generic-modal"]], decls: 5, vars: 2, consts: [[1, "prevent-overlap-with-close-button"], [1, "container"], [3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [3, "innerHTML"], [4, "ngTemplateOutlet"]], template: function GenericModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "egov-dialog-close-button")(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, GenericModalComponent_div_3_Template, 1, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, GenericModalComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.content);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.template);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.ɵa], styles: ["[_nghost-%COMP%]{max-width:100%}[_nghost-%COMP%]   .container[_ngcontent-%COMP%]{max-width:40em}"], changeDetection: 0 });
GenericModalComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
GenericModalComponent = __decorate([ __param(0, Inject(MAT_DIALOG_DATA))
], GenericModalComponent);

let GenericModalModule = class GenericModalModule {
};
GenericModalModule.ɵfac = function GenericModalModule_Factory(t) { return new (t || GenericModalModule)(); };
GenericModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GenericModalModule });
GenericModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        DialogCloseButtonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GenericModalComponent, [{
        type: Component,
        args: [{ selector: 'egov-generic-modal', template: "<egov-dialog-close-button></egov-dialog-close-button>\n<div class=\"prevent-overlap-with-close-button\"></div>\n<div class=\"container\">\n    <div *ngIf=\"content\" [innerHTML]=\"content\"></div>\n    <ng-container *ngIf=\"template\">\n        <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n    </ng-container>\n</div>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{max-width:100%}:host .container{max-width:40em}"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GenericModalModule, [{
        type: NgModule,
        args: [{
                declarations: [GenericModalComponent],
                imports: [
                    CommonModule,
                    DialogCloseButtonModule
                ],
                exports: [GenericModalComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GenericModalModule, { declarations: function () { return [GenericModalComponent]; }, imports: function () { return [CommonModule,
        DialogCloseButtonModule]; }, exports: function () { return [GenericModalComponent]; } }); })();

/*
 * Public API Surface of angular-generic-modal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenericModalComponent, GenericModalModule };

